import { render } from "./AdminMessages.vue?vue&type=template&id=2d6ac324"
import script from "./AdminMessages.vue?vue&type=script&lang=js"
export * from "./AdminMessages.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__